var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feature-request-container" }, [
    _c("h3", { staticClass: "mt-0 font-size-150 font-weight-normal" }, [
      _vm._v("\n        " + _vm._s(_vm.header) + "\n    "),
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.description))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column gap-20" },
      [
        !_vm.commentSent
          ? _c("TextArea", {
              staticClass: "w-100 feature-request-text-area",
              attrs: {
                id: "comment",
                name: "comment",
                value: _vm.comment,
                "border-class": "br-4",
                "max-characters": 280,
                rows: "3",
                aiCustom: true,
                id: "feature-request-form-textarea",
                type: "text",
              },
              model: {
                value: _vm.comment,
                callback: function ($$v) {
                  _vm.comment = $$v
                },
                expression: "comment",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.errorCommentEmpty
          ? _c("div", { staticClass: "alert alert-warning m-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Please enter your feedback!")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.commentSent
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success feature-request-submit-btn",
                    class: { disabled: _vm.loading === true },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("trans")("Submit")) +
                        "\n                "
                    ),
                    !_vm.loading
                      ? _c("i", { staticClass: "far fa-comment" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("i", {
                          staticClass: "fa fa-spin btn-loading-animation",
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "m-0 d-flex align-items-center gap-10" },
                  [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      on: { change: _vm.dismiss },
                    }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("trans")("Don't ask again")) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.loading === true
          ? _c("div", { staticClass: "alert alert-info m-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Submitting your feedback..")) +
                  "\n          "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.commentSent
          ? _c("span", { staticClass: "alert alert-info m-0" }, [
              _c("i", { staticClass: "fa fa-check" }),
              _vm._v(
                " " + _vm._s(_vm._f("trans")("Feedback sent")) + "\n        "
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }